import React from 'react';
import { useDeferredMedia } from '../hooks/useDeferredMedia';

// Below-fold background panel: identical DOM/classes/labels, but the image
// (with its gradient overlay) is only set once the panel nears the viewport.
const DeferredBackground: React.FC<{
  className: string;
  style?: React.CSSProperties;
  role?: string;
  'aria-label'?: string;
  backgroundImage: string;
}> = ({ className, style, role, 'aria-label': ariaLabel, backgroundImage }) => {
  const { ref, shouldLoad } = useDeferredMedia<HTMLDivElement>();
  return (
    <div
      ref={ref}
      className={className}
      role={role}
      aria-label={ariaLabel}
      style={{ ...style, ...(shouldLoad ? { backgroundImage } : {}) }}
    />
  );
};

export default DeferredBackground;
